module.exports = __webpack_public_path__ + "static/media/menu-open.5c9897df.svg";